import { restClient } from '@/Core'
import type { Message } from '../Contracts'
import { mapApiMessage, type ApiMessage } from '../Helpers/apiMappers'

interface EditMessageParams {
    messageId: string
    content: string
}

/** Edits own message content (backend allows the author only → 403 otherwise) */
export const EditMessageTask = async ({ messageId, content }: EditMessageParams): Promise<Message> => {
    const response = (await restClient.patch(`/services/chat/messages/${messageId}`, {
        json: { content },
    })) as ApiMessage | null

    return mapApiMessage(response ?? {})
}
